<script>
  import { filter, feeds } from "../stores.js";
</script>

<style>

  select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  text-align: center!important;
  text-align-last: center!important;
  /* webkit*/
 }

 .form-control:focus{
   box-shadow: none!important;
 }

 .selectText {
   font-size: 1.3rem;
 }

 @media (min-width: 576px) {
   .selectText {
     font-size:1.5rem;
   }

   select {
   -webkit-appearance: none;
   -moz-appearance: none;
   background: transparent;
   text-align: center!important;
   text-align-last: center!important;
   /* webkit*/
  }

  select::after{
    content: "sandy - ";
  }

  .form-control:focus{
    box-shadow: none!important;
  }
 }

</style>

{#await $feeds then feeds}
  <select class="form-control text-primary selectText text-center" bind:value={$filter}>
    <option value="">Tutti i contenuti</option>
    {#each feeds as feed}
      <option value={feed.metadata.identifier}>{feed.metadata.title}</option>
    {/each}
  </select>
{/await}
